import { Fetcher } from './../../utils/fetch'

// load qr list
export function loadQrList(page = 0, search = '', sort = '-createdAt') {
    return Fetcher.makeRequest(`qr?page=${page}&search=${search}&sort=${sort}`, `GET`);
}

// create new qr code
export function createQrCode(data = {}) {
    return Fetcher.makeRequest(`qr`, `POST`, data);
}

// update qr by id
export function updateQrCode(id = '', data = {}) {
    return Fetcher.makeRequest(`qr/${id}`, `PUT`, data);
}

// delete qr by id
export function deleteQr(id = '') {
    return Fetcher.makeRequest(`qr/${id}`, `DELETE`);
}


export function loadStats() {
    return Fetcher.makeRequest('stats', `GET`)
}



// WEBPACK FOOTER //
// ./src/containers/qr/api.js